import {
  ChangeDetectorRef,
  Component,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
import { IonAccordionGroup } from '@ionic/angular';
import { IntroductionTutorialComponent } from 'src/app/components/introduction-tutorial/introduction-tutorial.component';
import { EventService } from 'src/app/services/Events/events.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { WidgetsService } from 'src/app/services/ui/widgets.service';
import { ApiService } from './../../services/API/api.service';
import { CachingService } from './../../services/cache/caching.service';
import { SummaryComponent } from 'src/app/components/summary/summary/summary.component';
import { PostcodeComponent } from 'src/app/components/postcode/postcode.component';
import { TestDriveFormComponent } from 'src/app/components/test-drive-form/test-drive-form.component';
import { ViewOffersPopupComponent } from 'src/app/components/view-offers-popup/view-offers-popup.component';
import { AccessoriesService } from 'src/app/services/Accessories/accessory.service';
import { environment } from 'src/environments/environment';
import { FeedbackComponent } from 'src/app/components/feedback/feedback.component';
enum TutorialType {
  Tap = 'tap',
  Pinch = 'pinch',
}
@Component({
  selector: 'visualizer',
  templateUrl: 'visualizer.page.html',
  styleUrls: ['visualizer.page.scss'],
})
export class VisualizerPage implements OnInit {
  showData = false;
  hideColorPallette = true;
  hideTrimPallette = true;
  lastStateForColorPallette: boolean;
  hideInteractions = true;
  selectedVariant: any;
  selectedColor: any;
  selectedTrim: any;
  menuVisible = true;
  menuVisibleMobile = false;
  hideMenuButtons = false;
  tutorialRemovedFor3D = false;
  showTutorial = false;
  showTestDriveNudge = false;
  menuOpened = false;
  loader = true;
  @ViewChild('vsAccordion') vsAccordion: IonAccordionGroup;
  @ViewChild('ccAccordion') ccAccordion: IonAccordionGroup;
  defaultPack: any;
  // cc
  activeTab = 'accessories';
  interiorView = false;
  accessoryLoading: boolean;
  viewSummary = false;
  viewBreakup = false;
  showHeader = true;
  showResetButton = false;
  hideAccessories = true;
  hideAddons = true;
  disableAddons = true;
  timeoutId: any;
  hasTriggered = false;
  firstLoadComplete: boolean;
  isDisplayTutorial = true;
  isTutorialDisplayed = false;
  isAccessoryTutorialHide = false;
  tutorialType = '';
  tutorialTypes = TutorialType;
  constructor(
    private apiService: ApiService,
    private cachingService: CachingService,
    private modalController: ModalController,
    private events: EventService,
    private widgetService: WidgetsService,
    private router: Router,
    public globalService: GlobalService,
    private route: ActivatedRoute,
    private changeDetector: ChangeDetectorRef,
    private platform: Platform,
    private renderer: Renderer2,
    public accessoriesService: AccessoriesService
  ) {
    this.setGlobalVariablesFromURL();
    this.route.queryParams.subscribe(async (res) => {
      // setting utm params from url
      let utm = {
        utm_campaign: res.utm_campaign,
        utm_medium: res.utm_medium,
        utm_source: res.utm_source,
        utm_content: res.utm_content,
      };
      // setting cc/vs journey based from cc params in url
      let cc = res.cc;
      if (cc === 'true') {
        this.globalService.configurator = true;
        // adding configurator active class
        this.renderer.addClass(document.body, 'configurator-is-active');
      } else {
        this.globalService.configurator = false;
      }
      // setting pin_no & loading config from pin_no based in url
      let urlPin = res.pin;
      if (urlPin) {
        let pin = await this.cachingService.getDataFromSession('pin_no');
        // if pin exists then set pin, else create pin object & then set in session
        if (pin) {
          pin[this.globalService.vehicleCode] = urlPin;
        } else {
          pin = { [this.globalService.vehicleCode]: urlPin };
        }
        this.cachingService.setDataInSession('pin_no', pin);
      } else {
        // 'no pin in url'
      }
      // setting postcode in local passed in url : when user load config directly from pdf url
      let urlPcode = res.pcode;
      if (urlPcode) {
        this.cachingService.setDataInLocal('p_cd', urlPcode);
        this.globalService.postcode = urlPcode;
      } else {
        // 'no postcode in url'
      }
      this.cachingService.setDataInSession(
        'is_cc',
        this.globalService.configurator
      );
      this.cachingService.setDataInSession('utm_params', utm);
    });
    this.events.subscribe('nudgeUpdate', (res) => {
      if (res.val == false) {
        clearTimeout(this.timeoutId);
      } else {
        //
      }
    });
  }
  async initTimeout() {
    // const  val = await this.cachingService.getDataFromSession('modelSelected');
    // if (val.lms_integrated_code != "JL24"){
    if (this.firstLoadComplete && this.globalService.postcode) {
      this.timeoutId = setTimeout(() => {
        if (!this.hasTriggered && !this.globalService.isFeedbackformOpen) {
          this.testDriveFormModal();
          // this.hasTriggered = true;
        } else {
          this.globalService.testDriveFormMissed = true;
        }
      }, 60 * 1000);
    } else {
      return;
    }
    // }else{
    //Do nothing
    // }
  }
  setGlobalVariablesFromURL() {
    this.globalService.zipCode = this.route.snapshot.paramMap.get('zipCode');
    this.globalService.vehicleCode =
      this.route.snapshot.paramMap.get('vehicleCode');
    let cpos = this.route.snapshot.paramMap.get('cpos');
    if (cpos) {
      this.globalService.cpos = {
        modelID: cpos.split('-')[0],
        versionCode: cpos.split('-')[1],
        extraDigit: cpos.split('-')[2],
        seriesCode: cpos.split('-')[3],
      };
    }
    let optionalCodes = this.route.snapshot.paramMap.get('optionalCodes');
    if (optionalCodes) {
      this.globalService.optionalCodes = {
        exteriorCode: optionalCodes.split(',')[0],
        interiorCode: optionalCodes.split(',')[1],
        infotainmentCode: optionalCodes.split(',')[2],
        transmissionCode: optionalCodes.split(',')[3],
      };
    }
  }
  displayTutorial() {
    if (!this.isTutorialDisplayed) {
      if (!this.isAccessoryTutorialHide) {
        this.isDisplayTutorial = true; 
      }
      this.tutorialType = this.tutorialTypes.Tap;
      setTimeout(() => {
        this.tutorialType = this.tutorialTypes.Pinch;
        setTimeout(() => {
          this.displayTutorial();
        }, 4000);
      }, 4000);
    }
  }
  ngOnInit(): void {
    this.events.subscribe('events', (data) => {
      this.subscribeToEvents(data);
    });
    this.checkForAuthentication();
    this.globalService.activeTab = this.activeTab;
    this.apiService.sendReportingData({
      eName: 'page_view',
      eCat: 'home_page',
    });
  }
  ionViewWillEnter() {
    this.globalService.clearCacheForFinanceCalculators();
  }
  checkForAuthentication() {
    let token = sessionStorage.getItem('access-token');
    if (token == null) {
      this.apiService.authenticate().then((res) => {
        this.getModelData().then(() => {
          this.checkPostcode(); //to check if postcode is there or not
        });
      });
    } else {
      this.getModelData().then(() => {
        this.checkPostcode(); //to check if postcode is there or not
      });
    }
  }
  /**
   * To check if postcode already entered or not,
   * if not there then first take postcode input, based on that will load model & variant data first time
   * if already there then check for pin
   *
   */
  async checkPostcode() {
    const postcode = await this.cachingService.getDataFromLocal('p_cd');
    // if no postcode exist, open postcode modal, else check for pin
    if (!postcode) {
      const audio = new Audio('assets/sounds/notification.mp3');
      audio.play().catch(error => console.log('Audio play error:', error));
      // if no postcode exists, but pin exists i.e. loading from pin in url in new device, open postcode with old configtype
      // else open postcode with new configtype
      let pin_no = await this.cachingService.getDataFromSession('pin_no');
      if (pin_no && pin_no[this.globalService.vehicleCode]) {
        this.openPostcodeModal('old');
      } else {
        this.openPostcodeModal('new');
      }
      // this.widgetService.showLoader();
      this.loadCarWithoutPostcode();
    } else {
      this.checkPin();
    }
  }
  loadCarWithoutPostcode() {
    this.globalService
      .getVariantAll()
      .then(async (res) => {
        await this.setDataForVariant(res);
        this.events.publish('events', {
          startCarLoading: this.globalService.selectedVariant,
        });
      })
      .catch((err) => {
        console.error(err.error);
        this.widgetService.hideLoader();
        this.widgetService.toastWithButtons(err.error.message, 'danger');
      });
  }
  /**
   * To open postcode modal
   */
  async openPostcodeModal(configType) {
    const modal = await this.modalController.create({
      component: PostcodeComponent,
      componentProps: {
        contentData: {
          header: 'CONFIGURATOR_HEADER_MSG.HEADER',
          msgContent: 'CONFIGURATOR_HEADER_MSG.CONTENT',
        },
        type: configType,
      },
      backdropDismiss: false,
      cssClass: 'ONE3D-login-modal ' + ' auto-height',
      animated: false,
    });
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Click::Customer_Details',
      'postcode'
    );
    this.apiService.sendReportingData({
      eName: 'form_view',
      eCat: 'lead_form',
      eAct: 'proceed_to_enter',
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    if (data.type === 'new') {
      await this.cachingService.setDataInSession('oldConfiguration', false);
      this.setDataForVariant(data.res);
    } else if (data.type === 'old') {
      let pin_no = await this.cachingService.getDataFromSession('pin_no');
      await this.cachingService.setDataInSession('oldConfiguration', true);
      this.loadStoredConfiguration(
        data.res,
        pin_no[this.globalService.vehicleCode]
      );
    } else {
      // 'data type not matched on postcode modal dismiss'
    }
    this.initTimeout(); // test drive timer starts after postcode entered
    this.globalService.calculateColorAccTax();
  }
  async checkPin() {
    let pin_no = await this.cachingService.getDataFromSession('pin_no');
    if (pin_no && pin_no[this.globalService.vehicleCode]) {
      this.getDataFromSession('old', pin_no[this.globalService.vehicleCode]);
      this.apiService.updateReportingData(
        'pinId',
        pin_no[this.globalService.vehicleCode]
      );
    } else {
      this.getDataFromSession('new');
    }
  }
  getModelData() {
    return new Promise((resolve, reject) => {
      const requestBody = {
        lms_integrated_code: '', // will be dynamic if needed in future.
        shown_at: 'web',
      };
      this.apiService.get('model/all', requestBody).then(
        (res: any) => {
          let model: any;
          if (this.globalService.vehicleCode) {
            model = res.response.filter((ele) => {
              return ele.lms_integrated_code == this.globalService.vehicleCode;
            })[0];
          } else {
            model = res.response[0];
          }
          this.globalService.model = model;
          this.globalService.show_offer = model.show_offer;
          this.cachingService.setDataInSession('modelSelected', model);
          resolve(true);
        },
        (error) => {
          // this.widgetService.hideLoader();
          this.widgetService.toastWithButtons(
            'Something went wrong!',
            'danger'
          );
          reject(error);
        }
      );
    });
  }
  async getDataFromSession(configurationType, pin?) {
    const postcode = await this.cachingService.getDataFromLocal('p_cd');
    // this.widgetService.showLoader(); // hide due to double loader
    this.globalService
      .getVariantAll(postcode)
      .then(async (res) => {
        // this.widgetService.hideLoader(); // hide due to double loader
        if (configurationType == 'new') {
          await this.cachingService.setDataInSession('oldConfiguration', false);
          await this.setDataForVariant(res);
          this.events.publish('events', {
            startCarLoading: this.globalService.selectedVariant,
          });
        } else if (configurationType == 'old') {
          await this.cachingService.setDataInSession('oldConfiguration', true);
          this.loadStoredConfiguration(res, pin);
        }
        this.initTimeout();
      })
      .catch((err) => {
        console.error(err.error);
        // this.widgetService.hideLoader();
        if (err.error.message == 'Please enter valid postcode') {
          this.openPostcodeModal(configurationType);
        }
        this.widgetService.toastWithButtons(err.error.message, 'danger');
      });
  }
  async loadStoredConfiguration(variantsResponse, pin) {
    // incase of load stored config from url pin, variants is not getting set in session
    // so check if variants data already stored or not, if not then set it
    await this.cachingService.setDataInSession(
      'variants',
      variantsResponse.response
    );
    this.apiService
      .post('configuration/summary', { pin_no: pin })
      .then(async (res: any) => {
        this.apiService.updateReportingData('pinId', pin);
        let configuration = res.response[0];
        let variants = variantsResponse.response.variants;
        let selectedVariant = variants.filter((variant) => {
          return variant.variant_id == configuration.variant_id;
        })[0];
        this.globalService.variant_color_id = configuration.variant_color_id;
        this.globalService.trim_color_id = configuration.trim_color_id;
        this.globalService.buildName = configuration.build_name;
        this.globalService.addedAccessories.push(
          ...configuration.exteriorAccessories
        );
        this.globalService.addedAccessories.push(
          ...configuration.interiorAccessories
        );
        this.globalService.addedAccessories.push(
          ...configuration.addonsAccessories
        );
        this.globalService.addedAccessoriesPacks = configuration.packages;
        this.selectedVariant = selectedVariant;
        // set configuration id on loading stored config
        this.cachingService.setDataInSession('c_id', configuration.id);
        // set emi details in session
        this.cachingService.setDataInSession(
          'emi_details',
          configuration.FinanceOptions
        );
        setTimeout(() => {
          this.showData = true;
        }, 500);
        this.events.publish('events', {
          allVariants: res.response.variants,
        });
        this.events.publish('events', { defaultVariant: selectedVariant });
        const reportingData = {
          eLa1: this.globalService.model?.model_name,
          eLa2: this.selectedVariant.variant_name,
        };
        this.apiService.updateMultipleReportingData(reportingData);
        await this.globalService.getVariantDetails(selectedVariant);
        this.defaultPackageDetails();
        this.events.publish('events', {
          startCarLoading: this.globalService.selectedVariant,
        });
      });
  }
  setDataForVariant(res) {
    return new Promise(async (resp) => {
      await this.cachingService.setDataInSession('variants', res.response);
      let selectedVariant;
      if (
        this.globalService.vehicleCode &&
        this.globalService.zipCode &&
        this.globalService.cpos
      ) {
        if (this.globalService.optionalCodes) {
          selectedVariant = res.response.variants.filter((variant) => {
            return (
              variant.version_code == this.globalService.cpos.versionCode &&
              variant.series_code == this.globalService.cpos.seriesCode &&
              variant.transmission_code ==
                this.globalService.optionalCodes.transmissionCode
            );
          })[0];
        } else {
          selectedVariant = res.response.variants.filter((variant) => {
            return (
              variant.version_code == this.globalService.cpos.versionCode &&
              variant.series_code == this.globalService.cpos.seriesCode
            );
          })[0];
        }
      } else {
        selectedVariant = res.response.variants.filter((variant) => {
          return variant.is_default == 'yes';
        })[0];
      }
      this.selectedVariant = selectedVariant;
      setTimeout(() => {
        this.showData = true;
      }, 500);
      this.events.publish('events', {
        allVariants: res.response.variants,
      });
      this.events.publish('events', { defaultVariant: selectedVariant });
      const reportingData = {
        eLa1: this.globalService.model?.model_name,
        eLa2: this.selectedVariant.variant_name,
      };
      this.apiService.updateMultipleReportingData(reportingData);
      await this.globalService.getVariantDetails(selectedVariant);
      this.defaultPackageDetails();
      this.globalService.setConfigData().then(async () => {
        this.globalService.calculateColorAccTax();
      });
      resp(true);
    });
  }
  subscribeToEvents(data) {
    let key = Object.keys(data)[0];
    switch (key) {
      case 'firstLoadComplete':
        this.firstLoadComplete = true;
        this.initTimeout(); // removed due to start car loading without postcode
        if (!environment.hideTutorialModels.includes(this.globalService.vehicleCode)) {
          this.displayTutorial();
        }
        // if directly loading cc -> then to show color pallette & open menu setting value
        if (this.globalService.configurator) {
          this.hideColorPallette = false;
          this.menuVisible = true;
        } else {
          this.hideColorPallette = true;
        }
        // in mobile device to open menu on load, toggle menu for mobile
        if (this.globalService.getDeviceType() == 'mobile') {
          this.toggleMenuForMobile();
        }
        this.hideInteractions = false;
        this.resizeWindow();
        this.createConfig();
        this.loader = false;
        // this.getCustomerInfo();
        if (!this.globalService.configurator) {
          this.vsAccordion.value =
            this.globalService.model?.model_code == 'COMPASS'
              ? 'variants'
              : 'features';
        }
        const reportingData = {
          eLa1: this.globalService.model?.model_name,
          eLa2: this.selectedVariant.variant_name,
          eLa3: this.globalService.colorSelected
            ? this.globalService.colorSelected.color_name
            : 'Default Color',
        };
        this.apiService.updateMultipleReportingData(reportingData);
        // A/B testing nudge idea 4  //after merge of idea 2 & 3
        // show test drive nudge for idea 4 on VS/CC after 30secs of car load for mobile device
        setTimeout(() => {
          if (
            this.globalService.idea == 4 &&
            this.globalService.getDeviceType() === 'mobile'
          ) {
            this.showTestDriveNudge = true;
            this.apiService.logGAEvent(
              'uaevent',
              'Content',
              'Click::Nudges',
              'Popup open'
            );
            this.apiService.logGAEvent(
              'uaevent',
              'Content',
              'Click::Nudges::Set_' + this.globalService.idea,
              'Popup open::Set_' + this.globalService.idea
            );
            const audio = new Audio('assets/sounds/notification.mp3');
            audio.play().catch(error => console.log('Audio play error:', error));
            // Start loading the audio
            audio.load();
            // hide it after 10 secs of no interaction
            setTimeout(() => {
              this.showTestDriveNudge = false;
            }, 10000);
          }
        }, 30000);
        break;
      // case 'firstLoadBackgroundComplete':
      // this.displayTutorial();
      // break;
      case 'selectedVariant':
        this.selectedVariant = data.selectedVariant;
        this.defaultPackageDetails();
        break;
      case 'selectedColor':
        this.selectedColor = data.selectedColor;
        break;
      case 'selectedTrim':
        this.selectedTrim = data.selectedTrim;
        break;
      case 'view':
        switch (data.view.id) {
          case 'INT':
            this.interiorView = true;
            this.lastStateForColorPallette = this.hideColorPallette;
            this.hideColorPallette = true;
            this.hideTrimPallette = false;
            break;
          case 'EXT':
            this.interiorView = false;
            this.hideColorPallette = this.lastStateForColorPallette;
            this.hideTrimPallette = true;
            break;
          case 'INT_COMPLETE':
            this.openExploreTutorial();
            break;
          default:
            break;
        }
        break;
      case 'variantLoadStart':
        this.hideColorPallette = true;
        this.hideInteractions = true;
        break;
      case 'variantLoadComplete':
        this.hideColorPallette = false;
        this.hideInteractions = false;
        break;
      case 'featureShowcase':
        this.renderer.removeClass(
          document.body,
          'one3d-features-mobile-reel-view'
        );
        this.hideMenuButtons = data.featureShowcase;
        this.menuVisible = true;
        if (data.featureShowcase && !this.menuVisibleMobile) {
          this.toggleMenuForMobile();
        }
        this.resizeWindow();
        this.vsAccordion.value = 'features';
        this.changeDetector.detectChanges();
        break;
      case 'showColors':
        this.hideColorPallette = data.showColors;
        break;
      case 'showTrims':
        this.hideTrimPallette = data.showTrims;
        break;
      case 'accessoryLoading':
        this.accessoryLoading = true;
        this.hideColorPallette = true;
        this.hideTrimPallette = true;
        this.showResetButton = false;
        break;
      case 'accessoryLoadingComplete':
        this.accessoryLoading = false;
        this.showResetButton = true;
        break;
      case 'resetToDefault':
        this.hideColorPallette = false;
        this.hideTrimPallette = false;
        this.showResetButton = false;
        break;
      case 'navigateToConfigure':
        this.hideColorPallette = false;
        this.menuVisible = true;
        if (
          this.globalService.getDeviceType() == 'mobile' &&
          !this.menuVisibleMobile
        ) {
          this.toggleMenuForMobile();
        }
        this.globalService.configurator = true;
        //add class to body on back to cc
        this.renderer.addClass(document.body, 'configurator-is-active');
        this.resizeWindow();
        this.cachingService.setDataInSession(
          'is_cc',
          this.globalService.configurator
        );
        break;
      case 'backToVisualizer':
        // to remove all ion-modal in LHS panel on click of back to features CTA
        document.querySelectorAll('ion-modal').forEach((el) => {
          el.parentNode.removeChild(el);
        });
        this.globalService.configurator = false;
        //remove class from body on back to vs
        this.renderer.removeClass(document.body, 'configurator-is-active');
        this.viewSummary = false; // to show hide menu cta on visualizer
        this.cachingService.setDataInSession(
          'is_cc',
          this.globalService.configurator
        );
        break;
      case 'hideTutorial':
        this.isDisplayTutorial = false;
        this.isTutorialDisplayed = true;
        break;
      case 'accessoryShowTutorial':
        this.isAccessoryTutorialHide = false;
        this.isDisplayTutorial = !this.isTutorialDisplayed;
        break;
      case 'accessoryHideTutorial':
        this.isAccessoryTutorialHide = true;
        this.isDisplayTutorial = false;
        break;
      default:
        break;
    }
  }
  async openTutorialModal() {
    const modal = await this.modalController.create({
      component: IntroductionTutorialComponent,
      backdropDismiss: false,
      cssClass: 'one-3D-tutorialModal',
    });
    await modal.present();
  }
  async feedbackModal() {
    const modal = await this.modalController.create({
      component: FeedbackComponent,
      backdropDismiss: false,
      cssClass: 'one-3D-feedbackModal',
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    if (data && this.globalService.testDriveFormMissed) {
      setTimeout(() => {
        this.testDriveFormModal(true);
      }, 10000);
    }
  }
  async navigateToConfigurator() {
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Redirection::Internal',
      'Add Accessories'
    );
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Redirection::Internal::Set_' + this.globalService.idea,
      'Add Accessories::Set_' + this.globalService.idea
    );
    this.apiService.sendReportingData({
      eName: 'click',
      eCat: 'cta_clicked_visualizer',
      eAct: 'configure',
    });
    this.globalService.zipCode = this.route.snapshot.paramMap.get('zipCode');
    this.globalService.cpos = this.route.snapshot.paramMap.get('cpos');
    this.apiService.visualizerAnalytics('configure');
    /**
     *
     */
    // Get the current query parameters
    const queryParams = { ...this.route.snapshot.queryParams };
    // Add or update query parameters as needed
    queryParams['cc'] = 'true'; // Add or update 'cc'
    // Navigate to the same route with the updated query parameters
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams,
      // queryParamsHandling: 'merge', // Preserve existing query parameters
    });
    this.events.publish('events', {
      navigateToConfigure: null,
    });
  }
  changeVariant() {
    if (!this.menuVisible) {
      this.menuVisible = true;
    }
    this.vsAccordion.value = 'variants';
    this.apiService.logGAEvent('uaevent', 'Content', 'Click', 'change');
    this.resizeWindow();
    this.apiService.visualizerAnalytics('change_variant');
  }
  toggleMenu() {
    this.menuVisible = !this.menuVisible;
    this.menuOpened = true;
    this.showTutorial = false;
    this.resizeWindow();
    // added condition for now as in compass features tab is not supported
    if (!this.globalService.configurator) {
      this.vsAccordion.value =
        this.globalService.model?.model_code == 'COMPASS'
          ? 'variants'
          : 'features';
    } else {
      if (!this.menuVisible) {
        this.viewBreakup = false;
      }
    }
    // if in acc view & clicks on hide menu, then reset to default view
    if (this.showResetButton) {
      this.events.publish('events', { resetToDefault: null });
    }
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Click',
      this.menuVisible ? 'Open Menu' : 'Close Menu'
    );
    this.apiService.sendReportingData({
      eName: 'click',
      eCat: 'car_config_side_menu',
      eAct: this.menuVisible ? 'show_button_clicked' : 'hide_button_clicked',
    });
    if (this.menuVisible) this.apiService.visualizerAnalytics('explore_menu');
  }
  resizeWindow() {
    this.events.publish('events', {
      resize: null,
    });
  }
  toggleMenuForMobile() {
    this.menuVisibleMobile = !this.menuVisibleMobile;
    this.menuOpened = true;
    if (this.menuVisibleMobile) {
      this.events.publish('events', {
        fullscreen: false,
      });
      document
        .querySelector('.one3d-visualizer-wrapper')
        .classList.add('one3d-mobile');
      document
        .querySelector('.one3d-visualizer-wrapper')
        .classList.add('one3d-lhs-panel-open');
      this.apiService.visualizerAnalytics('explore_menu');
    } else {
      this.events.publish('events', {
        fullscreen: true,
      });
      document
        .querySelector('.one3d-visualizer-wrapper')
        .classList.remove('one3d-mobile');
      document
        .querySelector('.one3d-visualizer-wrapper')
        .classList.remove('one3d-lhs-panel-open');
    }
    // if in acc view & clicks on hide menu, then reset to default view
    if (this.showResetButton) {
      this.events.publish('events', { resetToDefault: null });
    }
    this.events.publish('events', {
      resize: null,
    });
    // added condition for now as in compass features tab is not supported
    if (!this.globalService.configurator) {
      this.vsAccordion.value =
        this.globalService.model?.model_code == 'COMPASS'
          ? 'variants'
          : 'features';
    } else {
      // 'toggleMenuForMobile in cc'
    }
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Click',
      this.menuVisibleMobile ? 'Open Menu' : 'Close Menu'
    );
  }
  changeVariantMobile() {
    this.menuVisibleMobile = !this.menuVisibleMobile;
    this.menuVisible = true;
    if (!this.menuVisibleMobile) {
      this.menuVisibleMobile = true;
    }
    if (this.menuVisibleMobile) {
      document
        .querySelector('.one3d-visualizer-wrapper')
        .classList.add('one3d-mobile');
    }
    this.apiService.logGAEvent('uaevent', 'Content', 'Click', 'change');
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Click::Set_' + this.globalService.idea,
      'change::Set_' + this.globalService.idea
    );
    this.events.publish('events', {
      resize: null,
    });
    this.vsAccordion.value = 'variants';
    this.apiService.visualizerAnalytics('change_variant');
  }
  testDrive() {
    //Open a modal,
    //Fill the form
    //If all validation done, proceed further.
    this.apiService.sendReportingData({
      eName: 'click',
      eCat: 'cta_clicked_visualizer',
      eAct: 'test_drive',
    });
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Redirection::InternalTestDrive',
      this.globalService.configurator
        ? 'test drive configurator'
        : 'test drive visualizer'
    );
    this.apiService.sendReportingData({
      eName: 'click',
      eCat: 'cta_clicked_visualizer',
      eAct: 'test_drive',
    });
    // let testDriveUrl = this.globalService.getTestDriveUrl();
    this.apiService.visualizerAnalytics('test_drive');
    this.testDriveFormModal(true);
    clearTimeout(this.timeoutId);
  }
  async testDriveFormModal(flag: boolean = false) {
    this.hasTriggered = true;
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'TDF::Cust_Details',
      'TDForm_popup'
    );
    const result = this.apiService.getResultantVariable(flag);
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'TDF::Cust_Details',
      `${'TDForm_popup'}_${result}`
    );
    clearTimeout(this.timeoutId);
    const modal = await this.modalController.create({
      component: TestDriveFormComponent,
      componentProps: {
        contentData: {
          header: 'CONFIGURATOR_HEADER_MSG.HEADER',
          msgContent: 'CONFIGURATOR_HEADER_MSG.CONTENT',
        },
        type: 'old',
        value: flag,
      },
      backdropDismiss: false,
      cssClass: 'one3d-test-drive-modal ' + ' auto-height',
      animated: false,
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
  }
  testDriveOld() {
    this.apiService.sendReportingData({
      eName: 'click',
      eCat: 'cta_clicked_visualizer',
      eAct: 'test_drive',
    });
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Redirection::InternalTestDrive',
      this.globalService.configurator
        ? 'test drive configurator'
        : 'test drive visualizer'
    );
    // A/B testing event
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Redirection::InternalTestDrive::Set_' + this.globalService.idea,
      this.globalService.configurator
        ? 'test drive configurator::Set_' + this.globalService.idea
        : 'test drive visualizer::Set_' + this.globalService.idea
    );
    this.apiService.sendReportingData({
      eName: 'click',
      eCat: 'cta_clicked_visualizer',
      eAct: 'test_drive',
    });
    let testDriveUrl = this.globalService.getTestDriveUrl();
    this.apiService.visualizerAnalytics('test_drive');
    window.open(testDriveUrl, '_parent');
  }
  reserveVehicle() {
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Redirection::InternalTestDrive',
      this.globalService.configurator
        ? 'test drive configurator'
        : 'test drive visualizer'
    );
    window.open('https://www.jeep.com.au/avenger/reservation.html', '_parent');
  }
  async showAusOffers() {
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Click:View_Offers',
      'pop up open'
    );
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Click:View_Offers::Set_' + this.globalService.idea,
      'pop up open::Set_' + this.globalService.idea
    );
    // let offersUrl = 'https://www.jeep.com.au/offers.html';
    // window.open(offersUrl, '_parent');
    const modal = await this.modalController.create({
      component: ViewOffersPopupComponent,
      backdropDismiss: false,
      animated: false,
      cssClass: 'one3d-offer-modal',
    });
    await modal.present();
  }
  openFeatures() {
    this.apiService.visualizerAnalytics('feature_menu');
  }
  inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }
  removeTutorial() {
    if (this.tutorialRemovedFor3D) return;
    this.events.publish('events', {
      removeTutorial: null,
    });
    this.tutorialRemovedFor3D = true;
  }
  async openExploreTutorial() {
    let exploreTutorialShown = await this.cachingService.getDataFromLocal(
      'em_t'
    );
    setTimeout(() => {
      if (!this.menuVisible && !this.menuOpened && !exploreTutorialShown) {
        const audio = new Audio('assets/sounds/notification.mp3');
        audio.play().catch(error => console.log('Audio play error:', error));
        this.cachingService.setDataInLocal('em_t', true);
        this.showTutorial = true;
      }
    }, 10000);
  }
  closeTutorial() {
    this.showTutorial = false;
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Click',
      'Close explore meridian tutorial'
    );
  }
  closeTestDriveNudge() {
    this.showTestDriveNudge = false;
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Click::Nudges',
      'Popup close'
    );
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Click::Nudges::Set_' + this.globalService.idea,
      'Popup close::Set_' + this.globalService.idea
    );
  }
  async createConfig() {
    let pin_no = await this.cachingService.getDataFromSession('pin_no');
    if (!pin_no || (pin_no && !pin_no[this.globalService.vehicleCode])) {
      this.globalService.configuration('create');
    } else {
      // 'createConfig : pin exists'
    }
  }
  sendReportAnalytics() {
    this.apiService.sendReportingData({
      eName: 'click',
      eCat: 'car_config_side_menu',
      eAct: 'variant_button_clicked',
    });
    this.apiService.visualizerAnalytics('variant_menu');
  }
  defaultPackageDetails() {
    this.defaultPack = this.selectedVariant?.packages.filter((pack) => {
      return pack.is_default == 'yes';
    });
  }
  //cc
  async viewCart() {
    let fb_shown = await this.cachingService.getDataFromLocal('fb_shown');
    this.apiService.logGAEvent('uaevent', 'Content', 'Click', 'View Cart');
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Click::Set_' + this.globalService.idea,
      'View Cart::Set_' + this.globalService.idea
    );
    this.viewSummary = true;
    this.globalService.activeTab = 'Summary';
    this.viewBreakup = false;
    if (!this.menuVisible) {
      this.toggleMenu();
    }
    this.events.publish('events', { resetToDefault: null });
    const modal = await this.modalController.create({
      component: SummaryComponent,
      backdropDismiss: false,
      animated: false,
      cssClass: 'one3d-sidePanelModal-summary',
      showBackdrop: false,
      backdropBreakpoint: 0,
    });
    await modal.present();
    if (!fb_shown) {
      setTimeout(() => {
        this.feedbackModal();
      }, 3000);
    } //open feedback modal on summary click if not shown before
    const { data } = await modal.onDidDismiss();
    this.viewSummary = false;
    if (data?.data == 'openAccessories') {
      if (!this.platform.is('android') && !this.platform.is('iphone')) {
        this.openAccordion('accessories');
      } else {
        this.openAccessories();
      }
    } else return null;
  }
  saveConfiguration() {
    this.globalService.openLoginModal('save');
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Click',
      'Download Button'
    );
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Click::Set_' + this.globalService.idea,
      'Download Button::Set_' + this.globalService.idea
    );
    this.apiService.visualizerAnalytics('save_and_share');
  }
  async toggleBreakup() {
    this.viewBreakup = !this.viewBreakup;
    if (this.viewBreakup) {
      if (!this.menuVisible) {
        this.toggleMenu();
      }
      this.apiService.logGAEvent('uaevent', 'Content', 'Click', 'View Breakup');
      this.apiService.logGAEvent(
        'uaevent',
        'Content',
        'Click::Set_' + this.globalService.idea,
        'View Breakup::Set_' + this.globalService.idea
      );
      this.apiService.sendReportingData({
        eName: 'click',
        eCat: 'view_breakup',
        eAct: 'view_breakup',
      });
    }
  }
  openAccordion(accordion) {
    this.activeTab = accordion;
    this.globalService.activeTab = this.activeTab;
    if (accordion == 'accessories') {
      this.apiService.logGAEvent('uaevent', 'Content', 'Click', 'accessories');
      this.apiService.sendReportingData({
        eName: 'click',
        eCat: 'accessorize_menu',
        eAct: 'accessorize_button_clicked',
      });
    }
  }
  ngOnDestroy() {
    clearTimeout(this.timeoutId);
  }
  async openAccessories() {
    this.apiService.logGAEvent('uaevent', 'Content', 'Click', 'accessories');
    this.apiService.sendReportingData({
      eName: 'click',
      eCat: 'accessorize_menu',
      eAct: 'accessorize_button_clicked',
    });
    this.hideAccessories = false;
    this.hideAddons = true;
    this.showHeader = false;
  }
  async openAddons() {
    this.hideAccessories = true;
    this.hideAddons = false;
    this.showHeader = false;
  }
  closeAccessories() {
    this.hideAccessories = true;
    this.hideAddons = true;
    this.showHeader = true;
  }
  closeAddons() {
    this.hideAccessories = true;
    this.hideAddons = true;
    this.showHeader = true;
  }
  resetToDefaultPosition() {
    this.events.publish('events', { resetToDefault: null });
    this.events.publish('events', { accessoryShowTutorial: true });
  }
}
